import { AxiosResponse } from 'axios';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IAssessmentTypeApi, api } from './base';

const baseRoute: string = 'AssessmentType';

export class AssessmentTypeApi extends IAssessmentTypeApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>, any>> {
    return api.get(`${baseRoute}/domain`);
  }
}

